import { X } from "lucide-react";
import type { TooltipRenderProps } from "react-joyride";
import { TourDemoAnimation } from "./TourDemoAnimation";
import type { TourDemoVariant } from "@/lib/product-tour/tour-steps";

export function TourTooltip({
  step,
  index,
  size,
  isLastStep,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
}: TooltipRenderProps) {
  // `step` é tipado como o `Step` genérico do react-joyride — `demo` é um campo próprio do
  // TourStep do app, não existe no tipo da lib.
  const demo = (step as { demo?: TourDemoVariant }).demo;
  return (
    <div
      {...tooltipProps}
      className={`rounded-xl border border-zinc-200 bg-white p-4 shadow-2xl dark:border-border dark:bg-card ${demo ? "w-[360px]" : step.placement === "center" ? "w-[400px]" : "w-[320px]"} max-w-[calc(100vw-2rem)]`}
    >
      <div className="mb-2 flex items-start justify-between gap-2">
        <div className="flex-1">
          {step.title && (
            <p className="text-sm font-semibold text-zinc-900 dark:text-foreground">{step.title}</p>
          )}
          <p className="mt-0.5 text-[11px] font-medium uppercase tracking-wide text-brand-600 dark:text-primary">
            Passo {index + 1} de {size}
          </p>
        </div>
        <button
          {...closeProps}
          type="button"
          aria-label="Fechar tour"
          className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-zinc-400 transition-colors hover:bg-zinc-100 hover:text-zinc-700 dark:hover:bg-muted dark:hover:text-foreground"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>

      {step.content && (
        <p className="text-[13px] leading-relaxed text-zinc-600 dark:text-muted-foreground">{step.content}</p>
      )}

      {demo && <TourDemoAnimation variant={demo} />}

      <div className="mt-4 flex items-center justify-between gap-2">
        <button
          {...skipProps}
          type="button"
          className="text-[12px] font-medium text-zinc-500 transition-colors hover:text-zinc-700 dark:text-muted-foreground dark:hover:text-foreground"
        >
          Pular tour
        </button>
        <div className="flex items-center gap-2">
          {index > 0 && (
            <button
              {...backProps}
              type="button"
              className="inline-flex h-8 items-center rounded-md border border-zinc-200 px-3 text-[12px] font-semibold text-zinc-700 transition-colors hover:bg-zinc-50 dark:border-border dark:text-foreground dark:hover:bg-muted"
            >
              Voltar
            </button>
          )}
          <button
            {...primaryProps}
            type="button"
            className="inline-flex h-8 items-center rounded-md bg-brand-600 px-3 text-[12px] font-semibold text-white transition-colors hover:bg-brand-700"
          >
            {isLastStep ? "Concluir" : "Próximo"}
          </button>
        </div>
      </div>
    </div>
  );
}
